import { render, staticRenderFns } from "./ai-builder-modal.vue?vue&type=template&id=2afdc496&scoped=true&"
import script from "./ai-builder-modal.vue?vue&type=script&lang=js&"
export * from "./ai-builder-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdc496",
  null
  
)

export default component.exports